import React, { useContext } from 'react';

import { QuestionSmileyRatingDefaultProps, QuestionSmileyRatingPropTypes } from 'src/components/JobDatasheet/propTypes';
import { DEFAULT_SMILEY_RATING } from 'src/components/JobDatasheet/JobDatasheetForm/constants';
import JobDatasheetLanguageContext from 'src/components/JobDatasheet/context/JobDatasheetLanguageContext';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const QuestionSmileyRating = ({
  isRectifiedQuestion,
  onChange,
  question: {
    smileyRatingSettings: { available, text },
    translations,
  },
  value,
  fromSurveyExecution = false,
}) => {
  const { selectedLanguage } = useContext(JobDatasheetLanguageContext);
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const defaultSmileyRating = DEFAULT_SMILEY_RATING;

  const getTranlatedText = (index) => {
    if (!selectedLanguage) {
      return text[index];
    }

    const textTranslation = (translations || []).find(c => c.languageId === selectedLanguage)?.options?.[index];

    return textTranslation?.value ?
      textTranslation.value :
      textTranslation || text[index];
  }

  const getReturnObject = val => {
    const returnObject = {
      ...value,
      type: 'smileyRating'
    };

    returnObject[selectedValueKey] = val;
    return returnObject;
  };

  return (
    <s.SmileyContainer fromSurveyExecution={fromSurveyExecution}>
    {available.map((val, index) => {
      return (
        <>
          {val && (
          <s.SmileyWrapper
            key={index}  
            selected={(value || {})[selectedValueKey] === (index + 1)}
            >
            <s.SmileyIcon
              name={defaultSmileyRating[index]}  
              onClick={e => {
                e.stopPropagation();
    
                onChange(getReturnObject(index + 1));
              }}
            />
            <pre>{getTranlatedText(index)}</pre>
          </s.SmileyWrapper>
          )}
        </>
      )
    })}
    </s.SmileyContainer>
  )
};

QuestionSmileyRating.propTypes = QuestionSmileyRatingPropTypes;
QuestionSmileyRating.defaultProps = QuestionSmileyRatingDefaultProps;
